import {TweenMax, Power2} from 'gsap';
import {Wordpress} from "src/modules/helper/wordpress/wordpress";

export class Forms {


  public static init() {
    Forms.setSelectFake();
    Forms.activeSelectFake();
  }


  // Fake selectbox
  public static setSelectFake() {
    $('.Form-select').each(function (index: number, value: any) {
      let $currentSelectFake = $(value);
      let $currentOptions = $currentSelectFake.find('option');

      $currentSelectFake.hide();

      let $selectFakeTmp = $('' +
        '<div class="SFake" data-opened="false">' +
        '<div class="SFake-button"></div>' +
        '<div class="SFake-chevron" data-svg="' + Wordpress.get_template_directory_uri() + '/src/assets/img/dropdown.svg"></div>' +
        '</div>' +
        '');

      // Ajout du sous menu
      let $dropdownFakeTmp = $('<ul class="SFake-dropdown"></ul>');

      $currentOptions.each(function (index: any, value: any) {
        let $currentOption = $(value);

        if ($currentOption.html().length > 0) {

          let $optionFakeTmp = $('<li class="SFake-option">' + $currentOption.html() + '</li>');

          if (index == 0 && !value.getAttribute('value') && value.hasAttribute('disabled')) {
            $optionFakeTmp = $('<li style="display: none;" class="SFake-option">' + $currentOption.html() + '</li>');
          }

          // On sélectionne l'optionFake si elle est sélectionnée dans le select
          if ($currentOption.attr('selected')) {
            $optionFakeTmp.addClass('selected');
            $selectFakeTmp.find('.SFake-button').html($currentOption.html());
          }

          $optionFakeTmp.data('SFakeOrigin', $currentOption);
          $dropdownFakeTmp.append($optionFakeTmp);
        }
      });

      $selectFakeTmp.append($dropdownFakeTmp);
      $selectFakeTmp.insertAfter($currentSelectFake);

    });
  }


  public static openSFakeDropdown($SFake: any) {
    let $SFakeDropdown = $SFake.find('.SFake-dropdown');
    let $SFakeChevron = $SFake.find('.SFake-chevron');

    $SFake.trigger('open');

    TweenMax.set($SFakeDropdown, {height: 'auto', autoAlpha: 1});
    TweenMax.from($SFakeDropdown, .2, {height: 0});
    TweenMax.to($SFakeChevron, .2, {rotation: -180});

    $SFake.data('opened', true);
  }


  public static closeSFakeDropdown($SFake: any) {

    let $SFakeDropdown = $SFake.find('.SFake-dropdown');
    let $SFakeChevron = $SFake.find('.SFake-chevron');

    $SFake.trigger('close');

    TweenMax.to($SFakeDropdown, .2, {height: 0, autoAlpha: 0});
    TweenMax.to($SFakeChevron, .2, {rotation: 0});

    $SFake.data('opened', false);
  }


  public static activeSelectFake() {
    let $SFake = $('.SFake');

    // Ouverture / Fermeture du dropdown
    $SFake.on('click', '.SFake-button', function () {

      let $this = $(this);
      let $SFake = $this.parents('.SFake');

      if ($SFake.data('opened') === false) {
        Forms.openSFakeDropdown($SFake);
      }
      else {
        Forms.closeSFakeDropdown($SFake);
      }

    });

    // Sélection d'une option
    $SFake.on('click', '.SFake-option', function () {
      let $this = $(this);
      let $SFake = $this.parents('.SFake');
      let $SFakeButton = $SFake.find('.SFake-button');

      // Modification du choix sur le select
      let $select = $SFake.siblings('select');
      let selectedOption = $this.data('SFakeOrigin');

      $select.find('option').removeAttr('selected');
      $select.find($(selectedOption)).attr('selected', 'selected');

      // Gestion de l'interface
      $SFakeButton.html($this.html());
      $this.siblings('.SFake-option').removeClass('selected');
      $this.addClass('selected');
      Forms.closeSFakeDropdown($SFake);

    });
  }


  public static triggerCloseSFakeDropdown(e: JQuery.Event) {
    if ($(e.target).closest('.SFake').length === 0) {
      Forms.closeSFakeDropdown($('.SFake'));
    }
  }

}